import React from 'react';
import { Gamepad2, Twitter, Facebook, Instagram, Youtube } from 'lucide-react';
export function Footer() {
  return <footer className="bg-candy-dark text-white pt-20 pb-10 relative overflow-hidden" data-id="element-24">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-candy-pink via-candy-purple to-candy-teal" data-id="element-25"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-26">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-27">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1" data-id="element-28">
            <div className="flex items-center gap-2 mb-6" data-id="element-29">
              <div className="bg-white/10 p-2 rounded-xl" data-id="element-30">
                <Gamepad2 className="text-candy-pink w-6 h-6" data-id="element-31" />
              </div>
              <span className="font-heading text-2xl font-bold" data-id="element-32">
                Prismgames
              </span>
            </div>
            <p className="text-candy-lavender mb-6 leading-relaxed" data-id="element-33">
              The safest playground on the internet. Curated, ad-free, and fun
              for everyone.
            </p>
            <div className="flex gap-4" data-id="element-34">
              {[Twitter, Facebook, Instagram, Youtube].map((Icon, i) => <a key={i} href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-candy-pink transition-colors" data-id="element-35">
                  <Icon size={18} data-id="element-36" />
                </a>)}
            </div>
          </div>

          {/* Links */}
          <div data-id="element-37">
            <h4 className="font-bold text-lg mb-6 text-candy-pink" data-id="element-38">Explore</h4>
            <ul className="space-y-3 text-candy-lavender" data-id="element-39">
              <li data-id="element-40">
                <a href="#games" className="hover:text-white transition-colors" data-id="element-41">
                  Games
                </a>
              </li>
              <li data-id="element-42">
                <a href="#features" className="hover:text-white transition-colors" data-id="element-43">
                  Features
                </a>
              </li>
              <li data-id="element-44">
                <a href="#pricing" className="hover:text-white transition-colors" data-id="element-45">
                  Pricing
                </a>
              </li>
              <li data-id="element-46">
                <a href="#about" className="hover:text-white transition-colors" data-id="element-47">
                  About Us
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-48">
            <h4 className="font-bold text-lg mb-6 text-candy-teal" data-id="element-49">Legal</h4>
            <ul className="space-y-3 text-candy-lavender" data-id="element-50">
              <li data-id="element-51">
                <a href="#" className="hover:text-white transition-colors" data-id="element-52">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-53">
                <a href="#" className="hover:text-white transition-colors" data-id="element-54">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-55">
                <a href="#" className="hover:text-white transition-colors" data-id="element-56">
                  Cookie Policy
                </a>
              </li>
              <li data-id="element-57">
                <a href="#" className="hover:text-white transition-colors" data-id="element-58">
                  Parental Guide
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-59">
            <h4 className="font-bold text-lg mb-6 text-candy-yellow" data-id="element-60">
              Contact
            </h4>
            <address className="not-italic text-candy-lavender space-y-3" data-id="element-61">
              <p data-id="element-62">Prismgames HQ</p>
              <p data-id="element-63">Limassol, Cyprus</p>
              <p className="mt-4 text-sm opacity-60" data-id="element-64">
                (No phone support available)
              </p>
            </address>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center text-candy-lavender text-sm" data-id="element-65">
          <p data-id="element-66">&copy; 2026 Prismgames. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}